export default __webpack_public_path__ + "static/B103-5f6f16ccd0f97950c175d6413fa1488c.jpg";